import styled from 'styled-components';

export const CustomTagsStyled = styled.div``;
